define(
    "diy/undo-redo/ExecutedEntry",
    [
    ],
    /**
     *
     */
    function () {
        'use strict';
        var
            defaultAction = function () {},
            ExecutedEntry
        ;

        /**
         * @class module.undoRedo.ExecutedEntry
         * @template module.undoRedo.ExecutedEntry
         * @lends {module.undoRedo.ExecutedEntry.prototype}
         * @constructor
         */
        ExecutedEntry = Klazz.extend({
            /** @type {*} */
            data: undefined,
            /** @type {Function|undefined} */
            onExecuted : undefined,
            /** @type {Function|undefined} */
            onExecutedLast : undefined,

            initialize: function initialize() {
                this.data = {};
                this.onExecuted = defaultAction;
                this.onExecutedLast = defaultAction;
            },
            /**
             *
             * @param {Function} callback
             * @param {*=} data
             */
            setOnExecuted: function setOnExecuted(callback, data) {
                if (typeof callback === 'function') {
                    this.onExecuted = callback;
                }
                this.data = data;
            },
            /**
             *
             * @param {Function} callback
             */
            setOnExecutedLast: function setOnExecutedLast(callback) {
                if (typeof callback === 'function') {
                    this.onExecutedLast = callback;
                }
            },
            /**
             *
             * @returns {*}
             */
            callOnExecuted: function callOnExecuted(){
                return this.onExecuted(this.data);
            },
            /**
             *
             * @returns {*}
             */
            callOnExecutedLast: function callOnExecuted(){
                return this.onExecutedLast(this.data);
            }
        });

        return ExecutedEntry;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/ExecutedEntry.js
 ** module id = 917
 ** module chunks = 0
 **/